/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TierType = "CORE" | "ENTERPRISE" | "FREE_FOREVER" | "LITE" | "PRO" | "TRIAL" | "%future added value";
export type HighLevelBudgetNumbers_company = {
    readonly tier: TierType | null;
    readonly id: string;
    readonly currency: string | null;
    readonly " $refType": "HighLevelBudgetNumbers_company";
};
export type HighLevelBudgetNumbers_company$data = HighLevelBudgetNumbers_company;
export type HighLevelBudgetNumbers_company$key = {
    readonly " $data"?: HighLevelBudgetNumbers_company$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"HighLevelBudgetNumbers_company">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HighLevelBudgetNumbers_company",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tier",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currency",
      "storageKey": null
    }
  ],
  "type": "Company"
};
(node as any).hash = 'c77081e59b3f2db9f138a9b36dfaa806';
export default node;
